import { useNavigate, useParams } from 'react-router-dom';

import { SusyTabItem } from './SusyTabItem';
import { SusyTabItemDefinition } from './interfaces';

import './SusyTabs.css';

type SusyTabsProps = {
    tabs: Array<SusyTabItemDefinition>;
    rootNavigation: string;
};

export const SusyTabs = ({ tabs, rootNavigation }: SusyTabsProps) => {
    const { currentTab: currentTabProps } = useParams();

    const navigate = useNavigate();

    const onClickTab = (currentTab: string) => {
        navigate(`${rootNavigation}/${currentTab}`);
    };

    const renderTabs = () => {
        return tabs.map((tab, index) => {
            return (
                <SusyTabItem
                    key={`${tab.tabHeader}${index}`}
                    tabName={tab.tabName}
                    tabHeader={tab.tabHeader}
                    onClick={tab.customClickNavigation ?? onClickTab}
                    selectedTabName={currentTabProps ?? ''}
                    tabLocalization={tab.tabHeader}
                    isSubTab={false}
                    isTabActive={tab.isTabActive}
                />
            );
        });
    };

    const renderTabsHeaderRightInsertContent = () => {
        const tabForRendering = tabs.find((tab) => checkIfCurrentTab(tab));
        return (
            <div className='d-flex susy-ml-2'>
                {tabForRendering?.renderHeaderRightInsert}
            </div>
        );
    };

    const renderTabsContent = () => {
        const tabForRendering = tabs.find(
            (tab) => checkIfCurrentTab(tab) && tab.content
        );

        const exactTabNotFound = !tabForRendering;
        if (exactTabNotFound && tabs.length > 0) {
            return tabs[0].content;
        }

        return tabForRendering?.content;
    };

    const checkIfCurrentTab = (tab: SusyTabItemDefinition) => {
        return (tab.tabName ?? tab.tabHeader) === currentTabProps;
    };

    return (
        <div>
            {/* Tabs */}
            <div
                className='susy-tabs-container'
                data-testid='susy-tabs-container'
            >
                <div className='susy-tabs-grow'>
                    <div className='susy-tabs'>{renderTabs()}</div>
                </div>
                {renderTabsHeaderRightInsertContent()}
            </div>

            {/* Content */}
            <div>{renderTabsContent()}</div>
        </div>
    );
};
